// PDP "Helps with" + accordion behaviour
// Scoped to sections with data-section-type="pdp-helps-with-accordion"

(function () {
  const ROOT_SELECTOR = '[data-section-type="pdp-helps-with-accordion"]';

  const isDesktop = () => window.matchMedia('(min-width: 901px)').matches;

  const sections = document.querySelectorAll(ROOT_SELECTOR);
  if (!sections.length) return;

  sections.forEach(sectionEl => {
    // Intersection Observer for "Helps with" animation
    const items = sectionEl.querySelectorAll('.helps-with-item');

    if (!('IntersectionObserver' in window) || !items.length) {
      items.forEach(el => el.classList.add('in-view'));
    } else {
      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('in-view');
              observer.unobserve(entry.target);
            }
          });
        },
        {
          root: null,
          threshold: 0.3
        }
      );

      items.forEach(el => observer.observe(el));
    }

    // Accordion behaviour: mobile = slide, desktop = fixed height + fade others
    const accordionSection = sectionEl.querySelector('.accordion-section');
    const accordionItems = accordionSection
      ? accordionSection.querySelectorAll('.accordion-item')
      : null;

    if (!accordionSection || !accordionItems || !accordionItems.length) return;

    // Initial state for panels (mobile slide behaviour)
    accordionItems.forEach(item => {
      const header = item.querySelector('.accordion-header');
      const panel = item.querySelector('.accordion-panel');

      if (!header || !panel) return;

      panel.style.maxHeight = '0px';
      panel.setAttribute('aria-hidden', 'true');
      header.setAttribute('aria-expanded', 'false');
    });

    accordionItems.forEach(item => {
      const header = item.querySelector('.accordion-header');
      const panel = item.querySelector('.accordion-panel');

      if (!header || !panel) return;

      header.addEventListener('click', () => {
        const alreadyOpen = item.classList.contains('is-open');

        if (isDesktop()) {
          // DESKTOP BEHAVIOUR
          if (alreadyOpen) {
            // Close everything and reset view
            accordionSection.classList.remove('accordion-section--open');
            accordionItems.forEach(other => {
              other.classList.remove('is-open', 'accordion-item--faded');
              const otherHeader = other.querySelector('.accordion-header');
              const otherPanel = other.querySelector('.accordion-panel');

              if (!otherHeader || !otherPanel) return;

              otherHeader.setAttribute('aria-expanded', 'false');
              otherPanel.setAttribute('aria-hidden', 'true');
              // Reset maxHeight so mobile slide still works if user resizes later
              otherPanel.style.maxHeight = '0px';
            });
          } else {
            accordionSection.classList.add('accordion-section--open');

            accordionItems.forEach(other => {
              const otherHeader = other.querySelector('.accordion-header');
              const otherPanel = other.querySelector('.accordion-panel');

              if (!otherHeader || !otherPanel) return;

              if (other === item) {
                other.classList.add('is-open');
                other.classList.remove('accordion-item--faded');

                otherHeader.setAttribute('aria-expanded', 'true');
                otherPanel.setAttribute('aria-hidden', 'false');
                // Let panel fill the available space on desktop
                otherPanel.style.maxHeight = 'none';
              } else {
                other.classList.remove('is-open');
                other.classList.add('accordion-item--faded');

                otherHeader.setAttribute('aria-expanded', 'false');
                otherPanel.setAttribute('aria-hidden', 'true');
                otherPanel.style.maxHeight = '0px';
              }
            });
          }
        } else {
          // MOBILE BEHAVIOUR – slide, single open
          accordionSection.classList.remove('accordion-section--open');

          accordionItems.forEach(other => {
            const otherHeader = other.querySelector('.accordion-header');
            const otherPanel = other.querySelector('.accordion-panel');

            if (!otherHeader || !otherPanel) return;

            other.classList.remove('accordion-item--faded');

            if (other === item && !alreadyOpen) {
              other.classList.add('is-open');
              otherHeader.setAttribute('aria-expanded', 'true');
              otherPanel.style.maxHeight = otherPanel.scrollHeight + 'px';
              otherPanel.setAttribute('aria-hidden', 'false');
            } else {
              other.classList.remove('is-open');
              otherHeader.setAttribute('aria-expanded', 'false');
              otherPanel.style.maxHeight = '0px';
              otherPanel.setAttribute('aria-hidden', 'true');
            }
          });
        }
      });
    });

    // Ingredients "Full Ingredients List" dropdown, scoped to this section
    const dropdownButtons = sectionEl.querySelectorAll('[data-ingredients-dropdown]');
    if (!dropdownButtons.length) return;

    dropdownButtons.forEach(button => {
      const panel = button.nextElementSibling;
      if (!panel || !panel.classList.contains('ingredients-dropdown-panel')) return;

      // Start collapsed
      panel.style.height = '0px';

      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        const accordionPanel = button.closest('.accordion-panel');

        if (!expanded) {
          // OPEN
          button.setAttribute('aria-expanded', 'true');

          // Measure full height, then animate to it
          panel.style.height = 'auto';
          const fullHeight = panel.scrollHeight;
          panel.style.height = '0px';
          requestAnimationFrame(() => {
            panel.style.height = fullHeight + 'px';
          });
        } else {
          // CLOSE
          button.setAttribute('aria-expanded', 'false');
          const currentHeight = panel.scrollHeight;
          panel.style.height = currentHeight + 'px';
          requestAnimationFrame(() => {
            panel.style.height = '0px';
          });
        }

        // On mobile, update parent accordion panel height so content isn't clipped
        if (accordionPanel && !isDesktop()) {
          // Wait until dropdown height transition kicks in, then re-measure
          setTimeout(() => {
            accordionPanel.style.maxHeight = accordionPanel.scrollHeight + 'px';
          }, 260);
        }
      });
    });
  });
})();
